var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0875 0.199806C11.2898 0.199806 11.4845 0.280384 11.6275 0.423439C11.7704 0.566403 11.8501 0.760386 11.8502 0.962502C11.8502 1.16481 11.7706 1.35949 11.6275 1.50254L7.10312 6.025L11.6275 10.5484C11.6982 10.6192 11.7543 10.7032 11.7926 10.7955C11.8309 10.888 11.8501 10.9874 11.8502 11.0875C11.8502 11.1876 11.8308 11.287 11.7926 11.3795C11.7542 11.472 11.6984 11.5567 11.6275 11.6275C11.5567 11.6984 11.472 11.7542 11.3795 11.7926C11.287 11.8309 11.1876 11.8502 11.0875 11.8502C10.9874 11.8502 10.888 11.8309 10.7955 11.7926C10.7032 11.7543 10.6191 11.6982 10.5484 11.6275L6.02499 7.10313L1.50253 11.6275C1.35948 11.7706 1.1648 11.8502 0.962494 11.8502C0.760379 11.8501 0.566396 11.7704 0.423431 11.6275C0.280376 11.4845 0.199799 11.2898 0.199799 11.0875C0.199881 10.8853 0.28045 10.6914 0.423431 10.5484L4.94589 6.025L0.423431 1.50254C0.280376 1.35949 0.199799 1.16481 0.199799 0.962502C0.199881 0.760304 0.28045 0.566421 0.423431 0.423439C0.566413 0.280458 0.760296 0.199889 0.962494 0.199806C1.1648 0.199806 1.35948 0.280384 1.50253 0.423439L6.02499 4.9459L10.5484 0.423439C10.6914 0.280458 10.8853 0.199889 11.0875 0.199806Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/Cancel.531ff7737d060cfac1f75935cf565be8.svg";
export { ForwardRef as ReactComponent };